import _ from 'lodash'
import { Notification } from 'element-ui'

export function replaceSpecialLetter(value) {
  let newValue = value

  newValue = newValue.replace(/－/g, '-')
  newValue = newValue.replace(/：/g, ':')
  newValue = newValue.replace(/０/g, '0')
  newValue = newValue.replace(/１/g, '1')
  newValue = newValue.replace(/２/g, '2')
  newValue = newValue.replace(/３/g, '3')
  newValue = newValue.replace(/４/g, '4')
  newValue = newValue.replace(/５/g, '5')
  newValue = newValue.replace(/６/g, '6')
  newValue = newValue.replace(/７/g, '7')
  newValue = newValue.replace(/８/g, '8')
  newValue = newValue.replace(/９/g, '9')

  return newValue
}


// const districtData = require('../assets/location')
// export function location() {
//   let antdDistrict = []
//   Object.keys(districtData).forEach(index => {
//     let itemLevel1 = {}
//     let itemLevel2 = {}
//     itemLevel1.value = districtData[index].name
//     itemLevel1.label = districtData[index].name
//     itemLevel1.children = []
//     let data = districtData[index].cities
//     Object.keys(data).forEach(index => {
//       itemLevel2.value = data[index].name
//       itemLevel2.label = data[index].name
//       itemLevel2.children = []
//       let data2 = data[index].districts
//       let itemLevel3 = {}
//       // itemLevel3.children = []
//       Object.keys(data2).forEach(index => {
//         itemLevel3.value = data2[index]
//         itemLevel3.label = data2[index]
//         itemLevel2.children.push(itemLevel3)
//         itemLevel3 = {}
//       })
//       itemLevel1.children.push(itemLevel2)
//       itemLevel2 = {}
//     })
//     antdDistrict.push(itemLevel1)
//   })
//   return antdDistrict
// }


export function location() {
  const districtData = require('../assets/newlocation')
  let arr1 = []
  _.map(districtData, i => {
    let arr2 = []
    _.map(i.children, j => {
      let arr3 = []
      _.map(j.children, k => {
        let obj3 = { label: k.name, value: k.name }
        arr3.push(obj3)
      })
      let obj2 = { label: j.name, value: j.name, children: arr3 }
      if (j.leaf) {
        obj2.leaf = true
      }
      arr2.push(obj2)
    })
    let obj1 = { label: i.name, value: i.name, children: arr2 }
    if (i.leaf) {
      obj1.leaf = true
    }
    arr1.push(obj1)
  })
  return arr1
}




export const copy = (value) => {
  var oInpurt = document.createElement('input')
  oInpurt.value = value
  document.body.appendChild(oInpurt)
  oInpurt.select()
  document.execCommand('Copy')
  oInpurt.style.display = 'none'
  document.body.removeChild(oInpurt)
  return true
}

export const tip = message => {
  Notification.error({
    title: 'Error',
    message,
    duration: 4000,
    showClose: false
  })
}